import type { MedChronTemplate } from "@/components/MedicalChronology/Visits/types";
import { useAPI } from "@/hooks/useAPI";
import { useCallback, useState } from "react";

export const useMedicalChronologyTemplate = (caseId: string) => {
  const api = useAPI();
  const [template, setTemplate] = useState<MedChronTemplate | null>(null);
  const [templateId, setTemplateId] = useState<string | null>(null);

  const loadTemplate = useCallback(async () => {
    try {
      const response = await api.get(`/med_chron/template/${caseId}`);
      setTemplate(response.data.template_data as MedChronTemplate);
      setTemplateId(response.data.template_id);
    } catch (error) {
      console.error("Error fetching template:", error);
      throw error;
    }
  }, [api, caseId]);

  return {
    template,
    templateId,
    loadTemplate,
  };
};
